import React, { FC } from "react";

type Props = Record<string, never>;
const AnimeFurusatoTerms: FC<Props> = () => {
  return (
    <>
      <section>
        <h1>
          <span style={{ display: "inline-block" }}>アニメふるさと納税</span>
          <span style={{ display: "inline-block" }}>に関する特約</span>
        </h1>
      </section>
      <section>
        <p>
          本特約は、当社が運営する「アニメファンド」を通じて提供されるサービス「アニメふるさと納税」の利用条件を定めるものです（以下「本特約」といいます）。
          アニメふるさと納税の利用にあたっては、アニメファンド利用規約（以下「原規約」といいます）に加えて、本特約のすべてに同意いただく必要があります。
          また、アニメふるさと納税の利用により、会員は、本特約及び会員が利用するサービスごとに定められたガイドラインや注意事項に同意したものとみなされます。
        </p>
      </section>
      <section>
        <h4>第１条（定義）</h4>
        <p>本特約において用いる用語の定義は次の通りとします。</p>
        <ul>
          {[
            {
              name: "アニメふるさと納税",
              description: "本サービスのうち、地方公共団体へ寄附することを可能にするサービス",
            },
          ].map((definition, index) => (
            <li key={index}>
              （{index + 1}）「{definition.name}」
              <br />
              {definition.description}
            </li>
          ))}
        </ul>
      </section>
      <section>
        <h4>第２条（プロジェクトの類型と成立）</h4>
        <p>
          <strong>１項</strong>
          プロジェクトは、成立条件の違いに応じて「All or Nothing方式」と「All in方式」とがあります。アニメふるさと納税におけるプロジェクトはすべて「All in方式」となります。
        </p>
        <ul>
          <li>
            （１）All in方式
            <br />
            募集期間内において、プロジェクトに対する応援が１円に到達した場合にプロジェクトが成立し、集まった応援額が目標金額に到達したか否かにかかわらずプロジェクトオーナーに支払われます。
          </li>
        </ul>
        <p>
          <strong>２項</strong>
          プロジェクトオーナーは、会員から請求があった場合は、会員に対する寄附証明書の発行等会員における税務手続きのために必要な対応を行うものとし、プロジェウクとオーナーが当該対応を怠ったことにより会員に損害が生じた場合でも、当社は、一切の責任を負わないものとします。
        </p>
      </section>
      <section>
        <h4>第３条（税務手続き）</h4>
        <p>会員は、応援に関連して税控除を受ける場合はかかる手続きを自己の責任で行うものとし、当社はかかる手続きに関しいかなる責任も負わないものとします。</p>
      </section>
      <section>
        <h4>第４条（適用）</h4>
        <p>本特約は、原規約に優先して適用されるものとします。また、本特約に定めのない事項は、原規約の定めに従うものとします。</p>
      </section>
    </>
  );
};
export default AnimeFurusatoTerms;
